import { PageType } from '@zotlo-shared/types/model';
import { setClientCookie, COOKIE } from '#shared/utils/cookie';
import { goToPage } from '#shared/utils/getBaseUrl'

export async function handleUserAlreadySubscribedError(subscriberId:string, cookiePath: string) {
  const subscriberIdValue = subscriberId?.charAt(0) === '+' ? subscriberId.substring(1) : subscriberId;
  setClientCookie(COOKIE.USER_ALREADY_SUBSCRIBED, 'true', undefined, cookiePath);
  setClientCookie(COOKIE.SUBSCRIBER_ID, subscriberIdValue, undefined, cookiePath);
  return goToPage(PageType.PAYMENT_SUCCESS, { excludeQueryParams: ['provider', 'code', COOKIE.SUBSCRIBER_ID] });
}
